import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/storeHooks";
import { fetchInspectionData } from "../store/thunks/inspectionThunks";
import { selectInspection } from "../store/selectors/inspectionSelectors";
import { ProgressSpinner } from "primereact/progressspinner";
import { DefectTable } from "../components/Defect/DefectTable";
import { TabPanel, TabView } from "primereact/tabview";
import { PositiveItemTable } from "../components/PositiveItem/PositiveItemTable";
import { InspectionInfo } from "../components/Inspection/InspectionInfo";
import { DefectDialog } from "../components/Defect/DefectDialog";
import { PositiveItemDialog } from "../components/PositiveItem/PositiveItemDialog";
import { DefectDeleteDialog } from "../components/Defect/DefectDeleteDialog";
import { PositiveItemDeleteDialog } from "../components/PositiveItem/PositiveItemDeleteDialog";
import { Card } from "primereact/card";
import { DefectImagesDialog } from "../components/Defect/DefectImagesDialog";
import { PositiveItemImagesDialog } from "../components/PositiveItem/PositiveItemImagesDialog";
import { EditDefectCodeDialog } from "../components/Defect/EditDefectCodeDialog";
import { ImagesGalleria } from "../components/Images/ImagesGalleria";
import { GenerateItemsDialog } from "../components/Shared/GenerateItemsDialog";

const Defects = () => {
    const dispatch = useAppDispatch();

    const { inspection, loading, error } = useAppSelector(selectInspection);

    const { inspectionId } = useParams();

    useEffect(() => {
        if (inspectionId) {
            dispatch(fetchInspectionData(inspectionId));
        }
    }, [inspectionId]);

    if (loading) {
        return (
            <div className="flex h-full align-items-center justify-content-center">
                <ProgressSpinner />
            </div>
        );
    }

    if (error || !inspection) {
        return (
            <div className="flex align-items-center justify-content-center">
                <p>Failed to get inspection :(</p>
            </div>
        );
    }

    return (
        <div>
            <InspectionInfo />
            <GenerateItemsDialog />
            <Card>
                <TabView>
                    <TabPanel header="Defects">
                        <DefectTable />
                        <DefectDialog />
                        <EditDefectCodeDialog />
                        <DefectImagesDialog />
                        <DefectDeleteDialog />
                    </TabPanel>
                    <TabPanel header="Positive Items">
                        <PositiveItemTable />
                        <PositiveItemDialog />
                        <PositiveItemImagesDialog />
                        <PositiveItemDeleteDialog />
                    </TabPanel>
                </TabView>
            </Card>
            <ImagesGalleria />
        </div>
    );
};

export default Defects;
